// src/config/brands/index.js

import { uvexBrandConfig } from './uvex';
import { aurexBrandConfig } from './aurex';

export const brandingConfig = {
    uvex: uvexBrandConfig,
    aurex: aurexBrandConfig
};

export const getCurrentBranding = () => {
    const brand = process.env.REACT_APP_BRAND;

    if (!brand) {
        throw new Error('REACT_APP_BRAND environment variable is not set. Please set it to "uvex" or "aurex".');
    }

    if (!brandingConfig[brand]) {
        throw new Error(`Invalid brand "${brand}". Supported brands: ${Object.keys(brandingConfig).join(', ')}`);
    }

    return brandingConfig[brand];
};

// Re-export for backward compatibility
export { uvexBrandConfig, aurexBrandConfig };
